import {
  GlobalMessageService,
  GlobalMessageType,
  GlobalMessageConfig,
} from '@spartacus/core';

export function ssGlobalMessageConfigFactory(): GlobalMessageConfig {
  return {
    globalMessages: {
      [GlobalMessageType.MSG_TYPE_ERROR]: {
        timeout: 15000,
      },
    },
  };
}
